export const CONTACT_HEADING = 'Contact Us';

export const PHONE = '+971 50 5254798';
export const EMAIL = 'info@alsamashipping.com';
export const LOCATION = 'Souq Al Khabeer , Dubai, UAE';

export const PHONE_LINK = 'tel:+971505254798';
export const EMAIL_LINK = 'mailto:info@alsamashipping.com';
export const MAP_LINK = 'https://www.google.com/maps?q=Souq+Al+Khabeer,+Dubai,+UAE';

export const PHONE_RAW = '971505254798';

export const CONTACT_NOTE = "We’re here to help. Drop us a line and we’ll get back to you as soon as possible.";
export const QUOTE_MESSAGE = "Hello, I’d like to request a shipping quote."